export default __webpack_public_path__ + "646dd0c5dccc6831d1d7deca9542e7e1.png";